<template>
    <div>
        <div class="row border-bottom">
            <div class="col-12">
                <div class="mb-2 float-right">
                    <div class="row">
                        <div class="col-xs-offset 1 col-xs-11 col-sm-offset-2 col-sm-8 col-md-offset-3 col-md-6">
                            <div class="btn-toolbar" role="toolbar">
                                <div class="btn-group btn-group-justified" role="group">
                                    <div class="btn-group" role="group">
                                        <button id="refresh" class="btn btn-primary" data-original-title="Refresh" @click="getClaimPaymentsForClaim(claimId)"><i class="fas fa-sync-alt" aria-hidden="true"></i></button>
                                    </div>
                                    <div class="btn-group" role="group">
                                        <button id="new" class="btn btn-primary" data-original-title="New" :disabled="isReadonly" @click="handleNewClick(claimId)"><i class="fas fas fa-plus" aria-hidden="true"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-if="loading && loading == true" class="row align-items-center justify-content-center">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>
        <table v-else class="table">
            <thead>
                <tr>
                    <th scope="col">Gadget</th>
                    <th scope="col">Payment Type</th>
                    <th scope="col">Reference</th>
                    <th scope="col">Payee Type</th>
                    <th scope="col">Provider</th>
                    <th scope="col">Transaction Type</th>
                    <th scope="col">Currency</th>
                    <th scope="col">Net</th>
                    <th scope="col">Tax</th>
                    <th scope="col">Gross</th>
                    <th scope="col">Date</th>
                    <th scope="col">Authorised Date</th>
                    <th scope="col">Authorised By</th>
                    <th scope="col">Actions</th>
                </tr>
            </thead>
            <tbody>
                <!-- :class="itm.transactionTypeId == 1 ? 'bg-danger' : 'bg-success'" -->
                <tr v-for="(itm, idx) in claimPayments" :key="'claimpaymentlist_' + idx"
                    :class="selectedRowIndex == idx ? 'table-primary' : ''"
                    :style="'cursor: pointer'"
                    @click="handleRowClick(idx, itm)">
                    <td>{{itm.gadgetDisplayLabel}}</td>
                    <td>{{getPaymentTypeLabel(itm)}}</td>
                    <td>{{itm.reference}}</td>
                    <td>{{itm.payeeTypeLabel}}</td>
                    <td>{{itm.settlementOptionProviderLabel}}</td>
                    <td>{{itm.transactionTypeLabel}}</td>
                    <td>{{itm.currencyCode}}</td>
                    <td>{{parseFloat(itm.net).toFixed(2)}}</td>
                    <td>{{parseFloat(itm.tax).toFixed(2)}}</td>
                    <td>{{parseFloat(itm.gross).toFixed(2)}}</td>
                    <td>{{localeString(itm.dateCreated)}}</td>
                    <td>{{localeString(itm.authorisedDate)}}</td>
                    <td>{{itm.authorisedByLabel}}</td>
                    <td>
                        <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret :boundary="'window'">
                            <template v-slot:button-content>
                                <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                                <span class="sr-only">Actions menu</span>
                            </template>
                            <b-dropdown-item href="javascript:void(0)" @click="handleEditClick(idx,itm)" :disabled="!canEdit(itm)">
                                <i v-if="false" :class="iconClass"></i> Edit
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleDeleteClick(idx,itm)" :disabled="!canDelete(itm)">
                                <i v-if="false" :class="iconClass"></i> Delete
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleCheckClick(idx,itm)" :disabled="!canCheck(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Check
                            </b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item href="javascript:void(0)" @click="handleAllocateClick(idx,itm)" :disabled="!canAllocate(idx,itm)">
                                <i v-if="false" :class="iconClass"></i> Allocate
                            </b-dropdown-item>
                            <b-dropdown-item href="javascript:void(0)" @click="handleAuthoriseClick(idx,itm)" :disabled="!canAuthorise(idx,itm).canAuthorise">
                                <i v-if="false" :class="iconClass"></i> Authorise
                            </b-dropdown-item>

                            <!--<b-dropdown-item href="javascript:void(0)" @click="handleCreateClaimPaymentClick(idx,itm)" :disabled="itm.claimPaymentId > 0">
                            <i v-if="false" :class="iconClass"></i> Create Claim Payment
                        </b-dropdown-item>-->
                        </b-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>
        <b-modal :id="'claim-payment-new-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer>
            <div>
                <b-list-group>
                    <b-list-group-item button v-for="(itm,idx) in paymentTypes" :key="'payment_type_' + idx" :active="newPayment.type == itm" :disabled="!itm.enabled" @click="newPayment.type = itm">{{itm.label}}</b-list-group-item>

                </b-list-group>
                <div v-if="newPayment.type== null" class="float-right">
                    <button type="button" class="btn btn-secondary mt-2" @click="handleNewCloseClick()">Close</button>
                </div>
            </div>
            <div v-if="newPaymentTypeId == 8">
                <hr />
                <div class="alert alert-info" role="alert">
                    Excess will not be applied to this payment type.
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Amount</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="newPayment.amount">
                        <div style="boder:1px; width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'amount').isValid">
                            {{newPayment.validators.find(v => v.item == 'amount').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" v-model="newPayment.reference">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reference').isValid">
                            {{newPayment.validators.find(v => v.item == 'reference').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reason</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <select class="form-control mt-2" v-model="newPayment.reason">
                            <option value="null">
                                SELECT...
                            </option>
                            <option v-for="(itm, idx) in compensationReasons" :key="'comp_reason_' + idx" :value="itm">
                                {{itm.label}}
                            </option>
                        </select>
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reason').isValid">
                            {{newPayment.validators.find(v => v.item == 'reason').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" @click="handleNewCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!addPaymentModelIsValid() || loading" @click="handleNewOKClick()">OK</button>
                </div>
            </div>
            <div v-if="newPaymentTypeId == 9">
                <hr />
                <div class="alert alert-info" role="alert">
                    Excess will not be applied to this payment type.
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Amount</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="newPayment.amount">
                        <div style="boder:1px; width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'amount').isValid">
                            {{newPayment.validators.find(v => v.item == 'amount').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" v-model="newPayment.reference">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reference').isValid">
                            {{newPayment.validators.find(v => v.item == 'reference').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reason</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <select class="form-control mt-2" v-model="newPayment.reason">
                            <option value="null">
                                SELECT...
                            </option>
                            <option v-for="(itm, idx) in fosReasons" :key="'fos_reason_' + idx" :value="itm">
                                {{itm.label}}
                            </option>
                        </select>
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reason').isValid">
                            {{newPayment.validators.find(v => v.item == 'reason').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" @click="handleNewCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!addPaymentModelIsValid() || loading" @click="handleNewOKClick()">OK</button>
                </div>
            </div>
            <div v-if="newPaymentTypeId == 10">
                <hr />
                <div class="alert alert-info" role="alert">
                    Excess will not be applied to this payment type.
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Amount</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="newPayment.amount">
                        <div style="boder:1px; width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'amount').isValid">
                            {{newPayment.validators.find(v => v.item == 'amount').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" v-model="newPayment.reference">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reference').isValid">
                            {{newPayment.validators.find(v => v.item == 'reference').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reason</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <select class="form-control mt-2" v-model="newPayment.reason">
                            <option value="null">
                                SELECT...
                            </option>
                            <option v-for="(itm, idx) in accessoriesReasons" :key="'accessories_reason_' + idx" :value="itm">
                                {{itm.label}}
                            </option>
                        </select>
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reason').isValid">
                            {{newPayment.validators.find(v => v.item == 'reason').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" @click="handleNewCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!addPaymentModelIsValid() || loading" @click="handleNewOKClick()">OK</button>
                </div>
            </div>
            <div v-if="newPaymentTypeId == 11">
                <hr />
                <div class="alert alert-info" role="alert">
                    Excess will not be applied to this payment type.
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Amount</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="newPayment.amount">
                        <div style="boder:1px; width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'amount').isValid">
                            {{newPayment.validators.find(v => v.item == 'amount').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" v-model="newPayment.reference">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reference').isValid">
                            {{newPayment.validators.find(v => v.item == 'reference').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Reason</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <select class="form-control mt-2" v-model="newPayment.reason">
                            <option value="null">
                                SELECT...
                            </option>
                            <option v-for="(itm, idx) in reimbursementReasons" :key="'reimbursement_reason_' + idx" :value="itm">
                                {{itm.label}}
                            </option>
                        </select>
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!newPayment.validators.find(v => v.item == 'reason').isValid">
                            {{newPayment.validators.find(v => v.item == 'reason').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" @click="handleNewCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!addPaymentModelIsValid() || loading" @click="handleNewOKClick()">OK</button>
                </div>
            </div>
        </b-modal>
        <b-modal :id="'claim-payment-edit-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer>
            <div v-if="selectedItem">
                <div class="row mt-2">
                    <div class="col pl-4 p-2">
                        <span>Gadget</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.gadgetDisplayLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payment Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.claimPaymentTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payee Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.payeeTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Provider</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.settlementOptionProviderLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Transaction Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.transactionTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Currency</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.currencyCode}}</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Currency</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <b-form-select id="claimPaymentCurrency" v-model="editAmountModel.currencyCode" :options="currencies"></b-form-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Net</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentNet" v-model="editAmountModel.net">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'net').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'net').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Tax</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentTax" v-model="editAmountModel.tax">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'tax').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'tax').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Gross</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="editAmountModel.gross">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!editAmountModel.validators.find(v => v.item == 'gross').isValid">
                            {{editAmountModel.validators.find(v => v.item == 'gross').inValidFeedback}}
                        </div>
                        <div v-if="isOverCoverLimit(editAmountModel.gross,gadget)" class="invalid-feedback d-block">
                            Amount is over cover limit, please check!
                        </div>
                    </div>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="loading" @click="handleCloseClick()">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!editAmountModelIsValid() || loading" @click="handleOKClick()">OK</button>
                </div>
            </div>
        </b-modal>
        <b-modal :id="'claim-payment-authoriseable-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer @hidden="authoriseCloseClick">
            <div v-if="selectedItem">
                <div class="row mt-2" v-if="selectedItem.gadgetDisplayLabel">
                    <div class="col pl-4 p-2">
                        <span>Gadget</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.gadgetDisplayLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payment Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.claimPaymentTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payee Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.payeeTypeLabel}}</span>
                    </div>
                </div>
                <div class="row" v-if="selectedItem.settlementOptionProviderLabel">
                    <div class="col pl-4 p-2">
                        <span>Provider</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.settlementOptionProviderLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Transaction Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.transactionTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Currency</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.currencyCode}}</span>
                    </div>
                </div>
                <div class="row" v-if="selectedItem.reference">
                    <div class="col pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.reference}}</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Net</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <span>{{selectedItem.net}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Tax</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <span>{{selectedItem.tax}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Gross</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <span>{{selectedItem.gross}}</span>
                    </div>
                </div>
                <div v-if="showAuthoriseableResult">
                    <hr />
                    <b-list-group v-if="authorisableResult != null">
                        <b-list-group-item v-for="(itm,idx) in authorisableResult.results">
                            <span :class="itm.passed==false ? 'text-danger' : 'text-success'"><strong>{{itm.message}}</strong></span>
                        </b-list-group-item>
                    </b-list-group>

                    <b-alert v-if="authorisableResult.canAuthorise == false" class="mt-3" show variant="danger">Please correct the above so the payment can be athorised!</b-alert>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="false" @click="authoriseCloseClick">Close</button>
                    <button type="button" class="btn btn-primary ml-2" :disabled="!authoriseButtonEnabled" @click="handleAuthoriseOkClick">Authorise</button>
                </div>
            </div>
        </b-modal>
        <b-modal :id="'claim-payment-check-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer @hidden="checkCloseClick">
            <div v-if="selectedItem">
                <div class="row mt-2" v-if="selectedItem.gadgetDisplayLabel">
                    <div class="col pl-4 p-2">
                        <span>Gadget</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.gadgetDisplayLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payment Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.claimPaymentTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payee Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.payeeTypeLabel}}</span>
                    </div>
                </div>
                <div class="row" v-if="selectedItem.settlementOptionProviderLabel">
                    <div class="col pl-4 p-2">
                        <span>Provider</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.settlementOptionProviderLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Transaction Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.transactionTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Currency</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.currencyCode}}</span>
                    </div>
                </div>
                <div class="row" v-if="selectedItem.reference">
                    <div class="col pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.reference}}</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Net</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <span>{{selectedItem.net}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Tax</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <span>{{selectedItem.tax}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Gross</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <span>{{selectedItem.gross}}</span>
                    </div>
                </div>
                <div v-if="showAuthoriseableResult">
                    <hr />
                    <b-list-group v-if="authorisableResult != null">
                        <b-list-group-item v-for="(itm,idx) in authorisableResult.results">
                            <span :class="itm.passed==false ? 'text-danger' : 'text-success'"><strong>{{itm.message}}</strong></span>
                        </b-list-group-item>
                    </b-list-group>

                    <b-alert v-if="authorisableResult.canAuthorise == false" class="mt-3" show variant="danger">Please correct the above!</b-alert>
                </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="false" @click="checkCloseClick">Close</button>
                </div>
            </div>
        </b-modal>
        <b-modal :id="'claim-payment-allocate-modal-' + $vnode.key" title="Claim Payment" size="lg" hide-footer @hidden="allocateCloseClick">
            <div v-if="selectedItem">
                <div class="row mt-2" v-if="selectedItem.gadgetDisplayLabel">
                    <div class="col pl-4 p-2">
                        <span>Gadget</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.gadgetDisplayLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payment Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.claimPaymentTypeLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Payee Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.payeeTypeLabel}}</span>
                    </div>
                </div>
                <div class="row" v-if="selectedItem.settlementOptionProviderLabel">
                    <div class="col pl-4 p-2">
                        <span>Provider</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.settlementOptionProviderLabel}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Transaction Type</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.transactionTypeLabel}}</span>
                    </div>
                </div>

                <div class="row" v-if="selectedItem.reference">
                    <div class="col pl-4 p-2">
                        <span>Reference</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <span>{{selectedItem.reference}}</span>
                    </div>
                </div>
                <hr />
                <div class="row">
                    <div class="col pl-4 p-2">
                        <span>Currency</span>
                    </div>
                    <div class="col-7 border-left pl-4 p-2">
                        <b-form-select id="claimPaymentCurrency" v-model="allocateModel.currencyCode" :options="currencies"></b-form-select>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Net</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentNet" v-model="allocateModel.net">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!allocateModel.validators.find(v => v.item == 'net').isValid">
                            {{allocateModel.validators.find(v => v.item == 'net').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Tax</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentTax" v-model="allocateModel.tax">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!allocateModel.validators.find(v => v.item == 'tax').isValid">
                            {{allocateModel.validators.find(v => v.item == 'tax').inValidFeedback}}
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-5 pl-4 p-2">
                        <span>Gross</span>
                    </div>
                    <div class="col-4 border-left pl-4 p-2">
                        <input type="text" class="form-control" id="claimPaymentGross" v-model="allocateModel.gross">
                        <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!allocateModel.validators.find(v => v.item == 'gross').isValid">
                            {{allocateModel.validators.find(v => v.item == 'gross').inValidFeedback}}
                        </div>
                        <div v-if="isOverCoverLimit(allocateModel.gross,gadget)" class="invalid-feedback d-block">
                            Amount is over cover limit, please check!
                        </div>
                    </div>
                </div>
                <div class="row">
        <div class="col-5 pl-4 p-2">
            <span>Job Number</span>
        </div>
        <div class="col-4 border-left pl-4 p-2">
            <input type="text" class="form-control" v-model="allocateModel.jobNumber">
            <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!allocateModel.validators.find(v => v.item == 'jobNumber').isValid">
                {{allocateModel.validators.find(v => v.item == 'jobNumber').inValidFeedback}}
            </div>
        </div>
    </div>
    <div class="row">
        <div class="col-5 pl-4 p-2">
            <span>Invoice Number</span>
        </div>
        <div class="col-4 border-left pl-4 p-2">
            <input type="text" class="form-control" v-model="allocateModel.invoiceNumber">
            <div style="width: 100%; margin-top: 0.25rem; font-size: 80%; color: #dc3545;" v-show="!allocateModel.validators.find(v => v.item == 'invoiceNumber').isValid">
                {{allocateModel.validators.find(v => v.item == 'invoiceNumber').inValidFeedback}}
            </div>
        </div>
    </div>
                <hr />
                <div class="float-right">
                    <button type="button" class="btn btn-secondary" :disabled="false">Close</button>
                    <button type="button" class="btn btn-primary ml-2" @click="handleAllocateOKClick()" :disabled="false">Allocate</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
    import { mapActions, mapGetters } from 'vuex'
    import axios from 'axios'
    import { API_BASE_URL } from '../globalVar'
    import { required, numeric, numericDecimal, minLen, numericDecimalMinVal } from '@/util/validators'
    import { runValidators, getValidators, getValidatorsIsValid } from '@/util/validation'
    import watchAll from '@/mixins/watchAll.js'
    import validator from '@/mixins/validator.js'
    import coverLimitHelper from '../mixins/coverLimitHelper'
    export default {
        name: 'ClaimPayments',
        props: {
            claimId: {
                type: Number,
                required: true
            },
            load: Boolean
        },
        mixins: [
            watchAll,
            validator,
            coverLimitHelper
        ],
        components: {},
        data: () => {
            return {
                baseUrl: API_BASE_URL,
                claimPayments: [],
                selectedRowIndex: null,
                selectedItem: null,
                editAmountModel: {
                    currencyCode: null,
                    net: 0,
                    tax: 0,
                    gross: 0,
                    validators: [
                        {
                            item: 'net',
                            validators: [
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'tax',
                            validators: [
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'gross',
                            validators: [
                                required,
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, Numeric'
                        }
                    ],
                },
                allocateModel: {
                    currencyCode: null,
                    net: 0,
                    tax: 0,
                    gross: 0,
                    jobNumber: null,
                    invoiceNumber: null,
                    validators: [
                        {
                            item: 'net',
                            validators: [
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'tax',
                            validators: [
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Numeric'
                        },
                        {
                            item: 'gross',
                            validators: [
                                required,
                                numericDecimal
                            ],
                            isValid: false,
                            inValidFeedback: 'Required, Numeric'
                        },
                        {
                            item: 'jobNumber',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'invoiceNumber',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        }
                    ],
                },
                loading: false,
                newPaymentType: null,
                newPayment: {
                    type: null,
                    amount: 0,
                    reference: null,
                    reason: null,
                    validators: [
                        {
                            item: 'type',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'reference',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'amount',
                            validators: [
                                required, numericDecimalMinVal(1)
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        },
                        {
                            item: 'reason',
                            validators: [
                                required
                            ],
                            isValid: false,
                            inValidFeedback: 'Required'
                        }
                    ],
                    reset: function () {
                        this.type = null
                        this.amount = 0
                        this.reference = null
                        this.reason = null
                    }
                },
                authorisableResult: { canAuthorise: false, results: [] },
                currencies: [
                    { value: 'GBP', text: 'GBP' },
                    { value: 'EUR', text: 'EUR' },
                ]
            }
        },
        watch: {
            load: async function (newVal, oldVal) {
                if (newVal == true) {
                    await this.getClaimPaymentsForClaim(this.claimId)
                }
            }
        },
        computed: {
            isReadonly() {
                return this.$adminUser.isReadonly();
            },
            gadget() {
                if (this.selectedItem) {
                    return { id: this.selectedItem.gadgetId }
                }
                return null
            },
            paymentTypes() {
                return [
                    {
                        id: 8,
                        label: 'Compensation - Claimant',
                        enabled: true
                    },
                    {
                        id: 9,
                        label: 'FOS fee',
                        enabled: true
                    },
                    {
                        id: 10,
                        label: 'Cash settlement  - accessories',
                        enabled: true
                    },
                    {
                        id: 11,
                        label: 'Reimbursement - Claimant',
                        enabled: true
                    }
                ]
            },
            compensationReasons() {
                return [
                    {
                        id: 1,
                        label: 'Complaint'
                    },
                    {
                        id: 2,
                        label: 'Interest'
                    },
                    {
                        id: 3,
                        label: 'Other'
                    }
                ]
            },
            fosReasons() {
                return [
                    {
                        id: 3,
                        label: 'Other'
                    }
                ]
            },
            accessoriesReasons() {
                return [
                    {
                        id: 3,
                        label: 'Other'
                    }
                ]
            },
            reimbursementReasons() {
                return [
                    {
                        id: 4,
                        label: 'Inspection Fee'
                    },
                    {
                        id: 5,
                        label: 'Excess Adjustment'
                    },
                    {
                        id: 3,
                        label: 'Other'
                    }
                ]
            },
            newPaymentTypeId() {
                if (this.newPayment && this.newPayment.type) {
                    return this.newPayment.type.id
                } else {
                    return 0
                }
            },
            authoriseButtonEnabled() {
                if (this.selectedItem == null)
                    return false;
                else {
                    if (this.authorisableResult.hasOwnProperty('id') && this.authorisableResult.id == this.selectedItem.id) {
                        return this.authorisableResult.canAuthorise;
                    } else {
                        return false;
                    }
                }

            },
            showAuthoriseableResult() {
                if (this.authorisableResult != null) {
                    if (this.authorisableResult.hasOwnProperty('results') && this.authorisableResult.results.length > 0) {
                        return true;
                    }
                }
                return false;
            }
        },
        methods: {
            ...mapActions({
                authoriseable: 'claimPayments/authoriseable',
                authorise: 'claimPayments/authorise',
                raiseToastMsg: 'notificationModule/toast',
                fetchGadgets: 'fetchGadgetsForClaim'
            }),
            async getClaimPaymentsForClaim(claimId) {
                if (claimId && !isNaN(claimId)) {
                    this.loading = true
                    try {
                        const response = await axios.get('/api/admin/v1/finance/claimpayments/' + claimId)
                        //console.log("-r : ", response)
                        const { data } = response
                        this.claimPayments = data
                    } catch (error) {
                        console.error(error)
                    } finally {
                        this.loading = false
                        this.$emit('finished-loading')
                    }
                }
            },
            handleRowClick(rowIndex, item) {
                this.selectedRowIndex = rowIndex
            },
            handleEditClick(rowIndex, item) {
                //console.log('-item: ', item)
                this.selectedItem = item
                this.editAmountModel.currencyCode = item.currencyCode
                this.editAmountModel.net = parseFloat(item.net).toFixed(2)
                this.editAmountModel.tax = parseFloat(item.tax).toFixed(2)
                this.editAmountModel.gross = parseFloat(item.gross).toFixed(2)
                this.$bvModal.show('claim-payment-edit-modal-' + this.$vnode.key)
            },
            async handleAuthoriseClick(rowIndex, item) {
                //console.log('handleAuthoriseClick')
                if (!this.canAuthorise(rowIndex, item)) {
                    let { gross } = item
                    this.raiseToastMsg(`Payment cannot be authorised because amount £${gross} is greater than your payment limit £${this.$adminUser.getPaymentApprovalLimit()}`)
                } else {
                    let { id, rv } = item
                    const result = await this.authoriseable({ claimPaymentId: id, rv })

                    //if (result.canAuthorise == false) {
                        this.selectedItem = item
                        this.authorisableResult = result
                    //} else {
                        //try {
                        //    const response = await this.authorise({ claimPaymentId: id, rv })
                        //    if (response) {
                        //        this.claimPayments = this.claimPayments.map(i => i.id !== response.id ? i : response)
                        //    }
                        //} catch (error) {
                        //    console.error(error)
                        //} finally { this.loading = false }
                    //}
                }

                this.selectedItem = item
                this.$bvModal.show('claim-payment-authoriseable-modal-' + this.$vnode.key)
            },
            async handleAllocateClick(idx, itm) {
                console.log('handleAllocateClick')
                console.log('-itm: ', itm)
                this.selectedItem = itm
                this.allocateModel.currencyCode = itm.currencyCode
                this.allocateModel.net = parseFloat(itm.net).toFixed(2)
                this.allocateModel.tax = parseFloat(itm.tax).toFixed(2)
                this.allocateModel.gross = parseFloat(itm.gross).toFixed(2)

                this.$bvModal.show('claim-payment-allocate-modal-' + this.$vnode.key)
            },
            authoriseCloseClick() {
                this.authorisableResult = { canAuthorise: false, results: [] }
                this.$bvModal.hide('claim-payment-authoriseable-modal-' + this.$vnode.key)
            },
            async handleCheckClick(rowIndex, item) {
                //console.log('handleCheckClick')
                
                let { id, rv } = item
                const result = await this.authoriseable({ claimPaymentId: id, rv })

                
                this.selectedItem = item
                this.authorisableResult = result
                
                this.$bvModal.show('claim-payment-check-modal-' + this.$vnode.key)
            },
            checkCloseClick() {
                this.authorisableResult = { canAuthorise: false, results: [] }
                this.$bvModal.hide('claim-payment-check-modal-' + this.$vnode.key)
            },
            handleNewClick() {
                this.newPayment.reset()
                this.newPaymentType = null
                this.$bvModal.show('claim-payment-new-modal-' + this.$vnode.key)
            },
            async handleDeleteClick(rowIndex, item) {
                this.selectedItem = item
                const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Delete this payment?')
                if (confirm != null) {
                    //console.log('-c : ', confirm)
                    if (confirm == true) {
                        let { id, rv } = this.selectedItem
                        let payload = {
                            claimPaymentId: id,
                            rv: rv
                        }
                        this.loading = true
                        try {
                            const response = await axios.post('/api/admin/v1/finance/deleteclaimpayment/', payload)
                            const { data } = response
                            if (data) {
                                this.claimPayments = this.claimPayments.filter(i => i.id !== data.id)
                            }
                        } catch (error) {
                            console.error(error)
                        } finally { this.loading = false }
                    }
                }
            },
            async handleAuthoriseOkClick(rowIndex, item) {

                item = this.selectedItem
                //console.log('handleAuthoriseOkClick')
                if (!this.canAuthorise(rowIndex, item)) {
                    let { gross } = item
                    this.raiseToastMsg(`Document cannot be approved because amount £${gross} is greater than your payment limit £${this.$adminUser.getPaymentApprovalLimit()}`)
                } else {
                    let { id, rv } = item
                    const result = await this.authoriseable({ claimPaymentId: id, rv })
                    if (result.canAuthorise == false) {
                        //this.selectedItem = item
                        this.authorisableResult = result
                        
                    } else { 
                    //this.selectedItem = item
                    const confirm = await this.$bvModal.msgBoxConfirm('Please confirm you want to Authorise this payment?')
                    if (confirm != null) {
                        //console.log('-c : ', confirm)
                        if (confirm == true) {
                            let { id, rv } = this.selectedItem
                            let payload = {
                                claimPaymentId: id,
                                rv: rv
                            }
                            //console.log('-p : ', payload)
                            this.loading = true
                            try {
                                const response = await this.authorise(payload)                            
                                if (response) {
                                    this.claimPayments = this.claimPayments.map(i => i.id !== response.id ? i : response)
                                    this.authorisableResult = null
                                    this.selectedItem == null
                                    this.$bvModal.hide('claim-payment-authoriseable-modal-' + this.$vnode.key)
                                }
                            } catch (error) {
                                console.error(error)
                            } finally { this.loading = false }
                        }
                        }
                    }
                }
            },
            canAuthorise(rowIndex, item) {
                if (item == null || this.isReadonly)
                    return { canAuthorise: false, results: null };

                let { authorised, claimPaymentTypeId, transactionTypeId, gross } = item
                if (gross > 0 && !authorised) {
                    if (authorised === false && (claimPaymentTypeId == 1 || claimPaymentTypeId == 2 || claimPaymentTypeId == 8 || claimPaymentTypeId == 10 || claimPaymentTypeId == 11) && transactionTypeId == 2) {
                        if (gross && this.$adminUser.getPaymentApprovalLimit() > gross) {
                            return { canAuthorise: true, results: [] };;
                        }
                    }
                }
                return { canAuthorise: false, results: null };
            },
            canAllocate(idx, itm) {
                if (itm == null || this.isReadonly)
                    return false;

                let { claimPaymentTypeId, transactionTypeId, gross, settlementOptionProviderLabel } = itm

                if (claimPaymentTypeId = 3 && settlementOptionProviderLabel == 'SPG' && transactionTypeId == 2) {

                    const exists = this.claimPayments.some(item =>
                        item.gadgetId === itm.gadgetId &&
                        item.settlementOptionId === itm.settlementOptionId &&
                        item.transactionTypeId === 1
                    );

                    return !exists;
                }
            },
            canCheck(rowIndex, item) {
                if (item == null || this.isReadonly)
                    return false;

                let { claimPaymentTypeId, transactionTypeId, gross, settlementOptionProviderLabel } = item
                if (gross > 0) {
                    if ((claimPaymentTypeId == 1 ||
                        claimPaymentTypeId == 2 ||
                        claimPaymentTypeId == 8 ||
                        claimPaymentTypeId == 10 ||
                        claimPaymentTypeId == 11) &&
                        transactionTypeId == 2) {
                        return true;
                    }
                } /*else {
                    if (claimPaymentTypeId = 3 && settlementOptionProviderLabel == 'SPG') {
                        return true;
                    }
                }*/
                return false;
            },
            canDelete(itm) {
                //console.log('itm: ', itm)
                //console.log('canDelete: ', !this.$adminUser.isReadonly() && itm.authorised == false)
                return !this.$adminUser.isReadonly() && itm.authorised == false;
            },
            canEdit(itm) {
                return !this.$adminUser.isReadonly() && itm.authorised == false;
            },
            editAmountModelRunValidators() { runValidators(this.editAmountModel) },
            editAmountModelIsValid() { return getValidatorsIsValid(this.editAmountModel) },
            addPaymentModelRunValidators() {
                //console.log('-addPaymentModelRunValidators: ', this.newPayment)
                runValidators(this.newPayment)
            },
            addPaymentModelIsValid() { return getValidatorsIsValid(this.newPayment) },
            allocateModelRunValidators() { runValidators(this.allocateModel) },
            allocateModelIsValid() { return getValidatorsIsValid(this.allocateModel) },
            async handleOKClick() {
                let { net, tax, gross, currencyCode } = this.editAmountModel
                if (gross && this.$adminUser.getPaymentApprovalLimit() < gross) {
                    this.raiseToastMsg(`Document cannot be approved because amount £${gross} is greater than your payment limit £${this.$adminUser.getPaymentApprovalLimit()}`)
                } else {
                    let { id, rv } = this.selectedItem
                    let payload = {
                        claimPaymentId: id,
                        net: parseFloat(net).toFixed(2),
                        tax: parseFloat(tax).toFixed(2),
                        gross: parseFloat(gross).toFixed(2),
                        rv: rv,
                        currencyCode
                    }
                    //console.log('-p : ', payload)
                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/finance/updateclaimpaymentamounts/', payload)
                        //console.log("-r : ", response)
                        const { data } = response
                        if (data) {
                            this.claimPayments = this.claimPayments.map(i => i.id !== data.id ? i : data)
                            this.$bvModal.hide('claim-payment-edit-modal-' + this.$vnode.key)
                        }
                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }
                }
            },
            async handleNewOKClick() {
                let { amount, reference, type, reason, currencyCode } = this.newPayment
                //console.log('-r: ', reason)
                if (amount && this.$adminUser.getPaymentApprovalLimit() < amount) {
                    this.raiseToastMsg(`Payment cannot be created because amount £${amount} is greater than your payment limit £${this.$adminUser.getPaymentApprovalLimit()}`)
                } else {
                    //console.log('-newPayment: ', this.newPayment)
                    let payload = {
                        claimId: this.claimId,
                        reference,
                        amount: parseFloat(amount).toFixed(2),
                        sourceEntityType: type.id,
                        reasonId: reason.id,
                        currencyCode
                    }
                    //console.log('-p : ', payload)
                    this.loading = true
                    try {
                        const response = await axios.post('/api/admin/v1/finance/createclaimpayment/', payload)
                        //console.log("-r : ", response)
                        const { data } = response
                        if (data) {
                            this.claimPayments = [...this.claimPayments, data]
                            this.$bvModal.hide('claim-payment-new-modal-' + this.$vnode.key)
                        }
                    } catch (error) {
                        console.error(error)
                    } finally { this.loading = false }
                }
            },
            async handleAllocateOKClick() {
                let { net, tax, gross, currencyCode, jobNumber, invoiceNumber } = this.allocateModel
                let { id, claimId, gadgetId, settlementOptionId } = this.selectedItem

                let payload = {
                    claimId,
                    sourceEntityId: id,
                    //gadgetId,
                    //settlementOptionId,
                    net: parseFloat(net).toFixed(2),
                    tax: parseFloat(tax).toFixed(2),
                    gross: parseFloat(gross).toFixed(2),
                    //amount: parseFloat(gross).toFixed(2),
                    currencyCode,
                    //jobNumber, invoiceNumber,
                    reference: invoiceNumber,
                    sourceEntityType: 5
                }

                console.log('-payload: ', payload)
                this.loading = true
                try {
                    const response = await axios.post('/api/admin/v1/finance/createclaimpayment/', payload)
                    //console.log("-r : ", response)
                    const { data } = response
                    if (data) {
                        this.claimPayments = [...this.claimPayments, data]
                        this.$bvModal.hide('claim-payment-allocate-modal-' + this.$vnode.key)
                    }
                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
                
            },
            async handleCreateClaimPaymentClick(idx, itm) {
                this.loading = true
                try {
                } catch (error) {
                    console.error(error)
                } finally { this.loading = false }
            },
            handleCloseClick() {
                this.$bvModal.hide('claim-payment-edit-modal-' + this.$vnode.key)
                this.selectedItem = null
                this.editAmountModel.net = 0
                this.editAmountModel.tax = 0
                this.editAmountModel.gross = 0
            },
            handleNewCloseClick() {
                this.$bvModal.hide('claim-payment-new-modal-' + this.$vnode.key)
                this.selectedItem = null
                this.editAmountModel.net = 0
                this.editAmountModel.tax = 0
                this.editAmountModel.gross = 0
                this.selectedItem = null
                this.newPayment.amount = 0
                this.newPayment.reference = 0
                this.newPayment.reason = null
                this.newPayment.type = null
            },
            allocateCloseClick() {
                this.$bvModal.hide('claim-payment-allocate-modal-' + this.$vnode.key)
                this.selectedItem = null
                this.allocateModel.net = 0
                this.allocateModel.tax = 0
                this.allocateModel.gross = 0
                this.allocateModel.jobNumber = null,
                this.allocateModel.invoiceNumber = null
            },
            localeString(val) {
                if (val != null) {
                    var dte = new Date(val)
                    if (typeof dte.getMonth === 'function' && !isNaN(dte.getMonth()))
                        return dte.toLocaleString('en-GB', { timeZone: 'Europe/London' })
                }
                return null
            },
            localeDateString(val) {
                var dte = new Date(val)
                if (typeof dte.getMonth === 'function' && !isNaN(dte.getMonth()))
                    return dte.toLocaleDateString('en-GB')
                return null
            },
            loadGadgetDetails() {
                if (this.selectedClaim) { /*authorisableResult*/
                    if (!this.selectedClaim.gadgetDetails || this.selectedClaim.gadgetDetails.length == 0) {
                        this.fetchGadgets(this.selectedClaim.claimId)
                    }
                }
            },
            getPaymentTypeLabel(itm) {

                if (itm.voucherTypeId != null)
                    return itm.claimPaymentTypeLabel + ` (${itm.voucherType})`

                if (itm.claimPaymentReasonId != null)
                    return itm.claimPaymentTypeLabel + ` (${itm.claimPaymentReason})`

                return itm.claimPaymentTypeLabel
            }
        },
        async beforeMount() {
            this.loadGadgetDetails()
        },
        async mounted() {
            this.watchAll(['editAmountModel.net', 'editAmountModel.tax', 'editAmountModel.gross'],
                this.editAmountModelRunValidators.bind(this))
            this.watchAll(['newPayment.type', 'newPayment.reference', 'newPayment.amount', 'newPayment.reason'],
                this.addPaymentModelRunValidators.bind(this))
            this.watchAll(['allocateModel.net', 'allocateModel.tax', 'allocateModel.gross', 'allocateModel.jobNumber', 'allocateModel.invoiceNumber'],
                this.allocateModelRunValidators.bind(this))
        },
    }
</script>
